import React from 'react';
import PropTypes from 'prop-types';
import { getAppraisalLandingLink } from 'site-modules/shared/utils/appraisal-link-constructor';
import { generateSrpLinkMakeModel } from 'site-modules/shared/utils/srp-link-constructor';
import { ArrowLink } from 'site-modules/shared/components/arrow-link/arrow-link';
import { VehicleEntities } from 'client/data/models/vehicle-v2';

export function ChangeVehicleLink({
  className = '',
  trackingValue = 'Change vehicle',
  isArrowLeft = false,
  isAppExtensionPage = false,
  color = undefined,
}) {
  return (
    <ArrowLink
      className={className}
      to={getAppraisalLandingLink({ isAppExtensionPage })}
      data-tracking-id="appraise_vehicle"
      data-tracking-value={trackingValue}
      isArrowLeft={isArrowLeft}
      color={color}
    >
      Change vehicle
    </ArrowLink>
  );
}

ChangeVehicleLink.propTypes = {
  className: PropTypes.string,
  trackingValue: PropTypes.string,
  isArrowLeft: PropTypes.bool,
  isAppExtensionPage: PropTypes.bool,
  color: PropTypes.string,
};

export function SeeAllForSaleLink({ vehicle = null, title = 'See all for sale' }) {
  if (!vehicle) return null;

  const { makeSlug, modelSlug } = vehicle;
  const seeAllFoSaleLink = generateSrpLinkMakeModel(makeSlug, modelSlug);

  return (
    <ArrowLink to={seeAllFoSaleLink} data-tracking-id="click_see_all_for_sale" data-tracking-value="See all for sale">
      {title}
    </ArrowLink>
  );
}

SeeAllForSaleLink.propTypes = {
  vehicle: VehicleEntities.StyleWithoutSubmodels,
  title: PropTypes.string,
};
